import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Compass } from "lucide-react";
import { api } from "@/lib/api";

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking"); // checking | ok

  useEffect(() => {
    let active = true;
    const token = sessionStorage.getItem("ft_admin_token");
    if (!token) {
      navigate("/admin", { replace: true });
      return;
    }
    api
      .get("/auth/me")
      .then(() => {
        if (active) setStatus("ok");
      })
      .catch(() => {
        sessionStorage.removeItem("ft_admin_token");
        navigate("/admin", { replace: true });
      });
    return () => {
      active = false;
    };
  }, [navigate]);

  if (status !== "ok") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-900 relative z-10" data-testid="auth-checking">
        <div className="flex items-center gap-2 text-slate-400">
          <Compass className="text-coastal-accent animate-pulse" size={20} />
          <span>Verificando sesión…</span>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
